import clsx from "clsx";
import useUsersChart from "./hooks/useUsersChart";
import StatsChartCard from "ui/stats/components/display/StatsChartCard/StatsChartCard";
import { UsersChartProps } from "./UsersChart.types";

function UsersChart({ className, ...rest }: UsersChartProps) {
    const props = useUsersChart();
    return <StatsChartCard className={clsx("users-chart", className)} {...props} {...rest} />;
}

export default UsersChart;
